export const BRAND_COLORS = {
  primary: '#014fa2',
  primaryHover: '#1d79dd',
  primaryActive: '#004386',
  accent: '#ff7f0d',
  surface: '#f5f8fc',
  surfaceElevated: '#ffffff',
  border: '#dbe5f1',
  text: '#172033',
  textSecondary: '#61708a',
};

export const WELZEK_THEME = {
  token: {
    colorPrimary: BRAND_COLORS.primary,
    colorInfo: BRAND_COLORS.primary,
    colorSuccess: '#1f9d55',
    colorWarning: BRAND_COLORS.accent,
    colorError: '#d92d20',
    colorText: BRAND_COLORS.text,
    colorTextSecondary: BRAND_COLORS.textSecondary,
    colorBorder: BRAND_COLORS.border,
    colorBgLayout: BRAND_COLORS.surface,
    colorBgContainer: BRAND_COLORS.surfaceElevated,
    borderRadius: 8,
    fontFamily:
      "'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    boxShadow:
      '0 12px 32px rgba(1, 79, 162, 0.10), 0 2px 8px rgba(23, 32, 51, 0.06)',
  },
  components: {
    Button: {
      borderRadius: 8,
      controlHeight: 34,
      controlHeightLG: 42,
      fontWeight: 600,
      primaryShadow: '0 8px 18px rgba(1, 79, 162, 0.18)',
    },
    Card: {
      borderRadiusLG: 8,
      boxShadowTertiary: '0 8px 24px rgba(1, 79, 162, 0.08)',
      headerBg: BRAND_COLORS.surfaceElevated,
    },
    Layout: {
      bodyBg: BRAND_COLORS.surface,
      headerBg: BRAND_COLORS.surfaceElevated,
      siderBg: '#08213f',
      triggerBg: '#08213f',
    },
    Menu: {
      darkItemBg: 'transparent',
      darkSubMenuItemBg: 'rgba(255, 255, 255, 0.04)',
      darkItemSelectedBg: BRAND_COLORS.primary,
      darkItemColor: 'rgba(255, 255, 255, 0.70)',
      darkItemHoverColor: '#ffffff',
      itemBorderRadius: 8,
    },
    Table: {
      headerBg: '#f0f5fb',
      headerColor: BRAND_COLORS.text,
      rowHoverBg: '#f6faff',
      borderColor: '#e4ebf5',
    },
    Tag: {
      borderRadiusSM: 6,
    },
  },
};
